


































import Vue from 'vue';
import {
  FirebaseLesson,
  Lang,
  Level,
  PersonalizedCourse,
  StatsCardData,
} from '@/store/types';
import LearningTools from '@/tools/learning';
import UserTools from '@/tools/user';

import StatsCard from '@/components/ui/StatsCard.vue';

export default Vue.extend({
  name: 'MyStats',
  components: {
    'stats-card': StatsCard,
  },
  data() {
    return {
      loading: true,
      langAudioData: new Map<string, number>(),
      ranks: new Map<string, number>(),
      statsCardData: new Array<StatsCardData>(),
    };
  },
  async mounted(): Promise<void> {
    const langLessons = this.getLangLessons();
    const langLessonKeys = Array.from(langLessons.keys()).filter((key: string) => !key.split(';')[2]);
    const promises = langLessonKeys.map((key: string) => {
      const langI = this.$store.state.langsI.find((lang: Lang) => key.split(';')[0] === lang.id);
      const langL = this.$store.state.langsL.find((lang: Lang) => key.split(';')[1] === lang.id);
      return LearningTools.loadMainLevels(this.$store, langI, langL);
    });
    const levelsData = await Promise.all(promises);
    const langAudioData = new Map<string, number>();
    for (let i = 0; i < levelsData.length; i += 1) {
      langAudioData.set(langLessonKeys[i], this.getLessonCountByLevelData(levelsData[i]));
    }
    this.langAudioData = langAudioData;
    const ranks = await UserTools.loadRanks(this.$store, langLessonKeys);
    this.ranks = ranks;

    const languagesISpeak = [...new Set(this.$store.state.userLessons
      .map((lesson: FirebaseLesson) => lesson.lang_i))];
    const statsCardData: Array<StatsCardData> = [];
    Array.from(langLessons.values()).forEach((lessons: Array<FirebaseLesson>) => {
      if (lessons.length > 0 && lessons[0]) {
        const audioCount = lessons.filter((lesson: FirebaseLesson) => lesson.completed).length;
        const quizCount = lessons.filter((lesson: FirebaseLesson) => lesson.score).length;
        let averageScore = -1;
        if (quizCount > 0) {
          averageScore = Math.round(lessons.filter((l) => l.score).map((l) => l.score)
            .reduce((a, b) => a + b, 0) / quizCount);
        }

        let showISpeak = false;
        if (languagesISpeak.length > 1) {
          showISpeak = true;
        }

        let personalizedLessonCount = 0;
        const firstLesson = lessons[0];
        if (firstLesson.personalized && this.$store.state.coursesPersonalized
          && this.$store.state.coursesPersonalized.length > 0
          && this.$store.state.coursesPersonalized.filter((course: PersonalizedCourse) => course.id
            .toString() === firstLesson.personalized).length > 0) {
          personalizedLessonCount = parseInt(this.$store.state.coursesPersonalized
            .filter((course: PersonalizedCourse) => course.id
              .toString() === firstLesson.personalized)[0].NumberWeeks, 10) * 5;
        }
        const statsLangId = this.getStatsLangId(firstLesson);
        const langIObj = this.$store.state.langsI
          .find((lang: Lang) => lang.id === firstLesson.lang_i);
        const langLObj = this.$store.state.langsL
          .find((lang: Lang) => lang.id === firstLesson.lang_l);
        const statsCard: StatsCardData = {
          showISpeak,
          statsLangId,
          langI: langIObj,
          langL: langLObj,
          personalizedTitle: ` (${firstLesson.personalized_label})`,
          personalized: firstLesson.personalized,
          audioData: {
            completed: audioCount,
            total: firstLesson.personalized
              ? personalizedLessonCount : (this.langAudioData.get(statsLangId) || 0),
          },
          quizData: {
            completed: quizCount,
            total: firstLesson.personalized ? personalizedLessonCount
              : (this.langAudioData.get(this.getStatsLangId(firstLesson)) || 0),
            averageScore,
            rank: this.ranks.get(this.getStatsLangId(firstLesson)) || 0,
          },
        };
        statsCardData.push(statsCard);
      }
    });
    this.statsCardData = statsCardData;
    this.loading = false;
    this.$store.commit('setMainLoading', false);
  },
  methods: {
    getLangLessons() {
      const lessons = this.$store.state.userLessons
        .filter((lesson: FirebaseLesson) => !lesson.isBookmark);
      const langLessons = new Map<string, Array<FirebaseLesson>>();
      for (let i = 0; i < lessons.length; i += 1) {
        if (Object.keys(langLessons).includes(this.getStatsLangId(lessons[i]))) {
          const tempArray: Array<FirebaseLesson> | undefined = langLessons
            .get(this.getStatsLangId(lessons[i]));
          if (tempArray) {
            tempArray.push(lessons[i]);
            langLessons.set(this.getStatsLangId(lessons[i]), tempArray);
          } else {
            langLessons.set(this.getStatsLangId(lessons[i]), [lessons[i]]);
          }
        } else {
          langLessons.set(this.getStatsLangId(lessons[i]), [lessons[i]]);
        }
      }
      return langLessons;
    },
    getStatsLangId(lesson: FirebaseLesson) {
      return `${lesson.lang_i};${lesson.lang_l};${lesson.personalized}`;
    },
    getLessonCountByLevelData(levelData: Array<Level>) {
      let lessonCount = 0;
      for (let i = 0; i < levelData.length; i += 1) {
        const level = levelData[i];
        if (level.obj_id === '1') {
          lessonCount += 141;
        } else if (level.obj_id === '2') {
          lessonCount += 300;
        } else if (level.obj_id === '3') {
          lessonCount += 279;
        } else if (level.obj_id === '4') {
          lessonCount += 85;
        } else if (level.obj_id === '5') {
          lessonCount += 77;
        }
      }
      return lessonCount;
    },
  },
});

